<script lang="ts">
    export let color: "primary" | "secondary" = "secondary";
</script>

<span class="rounded-full {color === "primary" ? "text-secondary": "text-primary"} px-4 py-2 bg-{color} text-sm font-light">
    <slot />    
</span>